import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { BulkLink, Link, LinkSpecDetail, Links, LinksDTO } from "@webapp/links/models/links.models";
import { LinksState } from "@webapp/links/services/links-state.service";
import { IUpdateItemLinks } from "../models/links-api.models";
import { LinksApiService } from "./links-api.service";

@Injectable({
  providedIn: "any",
})
export class LinksFacade extends BaseFacade<Links<LinkSpecDetail>, LinksDTO<Link>, LinksState, LinksApiService> {
  constructor(state: LinksState, api: LinksApiService) {
    super(state, api);
  }

  public createLink$(link: LinksDTO<Link>): Observable<Links<LinkSpecDetail>> {
    return this.post$({}, { ...new RequestConfig(), url: this.apiService.getLinkActionEndpoint(link) });
  }

  public deleteLink$(link: LinksDTO<Link>): Observable<void> {
    return this.delete$(null, { ...new RequestConfig(), url: this.apiService.getLinkActionEndpoint(link) });
  }

  public createBulkLink$(bulkLink: BulkLink, body: LinksDTO<Link>): Observable<Links<LinkSpecDetail>> {
    // you can omit the casting and use it directly like this in your Component as
    // this.linksFacade.post$(body, this.linksFacade.getApiService().getBulkLinkActionEndpoint(bulkLink));

    return this.post$(body, { ...new RequestConfig(), url: this.apiService.getBulkLinkActionEndpoint(bulkLink) });
  }

  public patchBulkLink$(bulkLink: BulkLink, body: IUpdateItemLinks): Observable<Links<LinkSpecDetail>> {
    // you can omit the casting and use it directly like this in your Component as
    // this.linksFacade.patch$(body, this.linksFacade.getApiService().getBulkLinkActionEndpoint(bulkLink));

    return this.patch$(null, body as unknown, { ...new RequestConfig(), url: this.apiService.getBulkLinkActionEndpoint(bulkLink) });
  }

  public canLinkInfo$(bulkLink: BulkLink, body: LinksDTO<Link>): Observable<Links<LinkSpecDetail>> {
    return this.post$(body, { ...new RequestConfig(), url: `${this.apiService.getBulkLinkActionEndpoint(bulkLink)}/can-link-info` });
  }
}
